import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorsService} from './errors.service';
import {NotificationService} from '../notification';
import {
  ActivationProductErrorResponse,
  BaseCustomErrorResponse,
  CustomErrorPageResponse,
  CustomErrorResponse,
  DetailProductErrorResponse,
  MaintenanceErrorResponse,
  SessionExpiredErrorResponse
} from '../api/custom-error-response.type';
import {BridgeService} from '../bridge';
import {CustomErrorService} from '../../shared/errors/custom-error/custom-error.service';
import { datadogLogs } from '@datadog/browser-logs';

@Injectable()
export class ErrorsHandlerService implements ErrorHandler {
  constructor(
    private injector: Injector
  ) {
  }

  handleError(error: Error | HttpErrorResponse | CustomErrorResponse) {
    const errorService = this.injector.get(ErrorsService);
    const notification = this.injector.get(NotificationService);
    const customError = this.injector.get(CustomErrorService);
    const bridge = this.injector.get(BridgeService);

    errorService.log(error).subscribe();

    if (error instanceof SessionExpiredErrorResponse) {
      return bridge.restartFlowPopup('Gentile utente, la tua sessione è scaduta.',true);
    }

    if (error instanceof MaintenanceErrorResponse) {
      return notification.notify(error.message);
    }
    if (error instanceof DetailProductErrorResponse) {
      return notification.notify(error.message);
    }
    if (error instanceof ActivationProductErrorResponse) {
      datadogLogs.logger.error('Errore durante l attivazione' + error.code + error.message);
      return notification.notify(error.message);
    }
    if ((error as BaseCustomErrorResponse).globalHandler) {
      if (error instanceof CustomErrorResponse) {
        try {
          datadogLogs.logger.error('An error popup has been shown. ' + error?.code + ' | ' + error?.message ,{
            error
          });
        } catch (error) {
          console.error(error);
        }

        return notification.notify();
      } else if (error instanceof CustomErrorPageResponse) {
        return customError.open(error.code);
      }
    }
  }

}
